import { Box, Divider, Flex, IconButton, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { FiCheck, FiHome, FiLogIn, FiLogOut, FiMenu } from "react-icons/fi";
import { RiFileEditLine, RiProfileFill } from "react-icons/ri";
import { VscOutput } from "react-icons/vsc";
import { MdOutlineNoEncryptionGmailerrorred } from "react-icons/md";
import { FaHistory } from "react-icons/fa";
import { RiAdminLine } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import NavItem from "./NavItem";
import { useDispatch, useSelector } from "react-redux";
import { logoutAPI } from "../../Redux/Auth/auth.action";
import { GiUpgrade } from "react-icons/gi";
import { TbDelta } from "react-icons/tb";
import { MdMovieEdit } from "react-icons/md";
const SideBar = ({ navSize, changeNavSize }) => {
  const location = useLocation();

  const { isAuth, token, user } = useSelector((state) => state.auth);
  // console.log("user", user);

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (!isAuth && !token) {
  //     navigate("/login");
  //   }
  // }, [isAuth, token, navigate]);

  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logoutAPI());
    // navigate("/login");
  };

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <Flex
      w="100%"
      transition="width 0.2s ease-in-out, padding 0.2s ease-in-out"
      pos="sticky"
      left="0"
      top="70px"
      h="calc(100vh - 70px)"
      bgColor="#1A174E"
      // bgColor="#202123"
      boxShadow="0 4px 12px 0 rgba(0,0,0,0.5)"
      // borderTopLeftRadius={navSize === "small" ? "15px" : "30px"}
      flexDir="column"
      justifyContent="space-between"
    >
      <Flex p="5%" flexDir="column" alignItems="flex-start" as="nav">
        {/* <IconButton
          background="none"
          mt="5"
          _hover={{ background: "none" }}
          color="white"
          icon={<FiMenu />}
          onClick={() => {
            if (navSize === "large") {
              changeNavSize("small");
            } else {
              changeNavSize("large");
            }
          }}
        /> */}
        <Flex
          mt="30"
          flexDir="column"
          w="100%"
          p={navSize === "small" ? "2" : "0"}
          alignItems={navSize === "small" ? "center" : "flex-start"}
        >
          <Box
            px="3"
            py={navSize === "small" ? "2" : "0"}
            color={navSize === "small" ? "white" : "white"}
            // fontSize="lg"
            borderColor={navSize === "small" ? "white" : "none"}
            borderRadius={navSize === "small" ? "base" : ""}
            fontWeight="semibold"
          >
            {user?.name && (
              <Flex direction="column" align="center" justify="center">
                <RiProfileFill size="30" />
                <Text
                  textTransform="capitalize"
                  // fontSize="12"
                >
                  {user.name}
                </Text>
              </Flex>
            )}

            {/* {navSize === "small" ? (
              <>{user?.name.split(" ").map((text) => text[0])}</>
            ) : (
              `Hi, ${user?.name}!`
            )} */}
          </Box>
          {/* role of user */}
          {navSize === "large" && (
            <Text
              px="3"
              pb="3"
              color="lightgray"
              fontSize="sm"
              textTransform="capitalize"
            >
              ({user.role})
            </Text>
          )}
        </Flex>
        <Divider border="1px solid white" w="90%" m="auto" mb="3rem" />

        <NavItem
          navSize={navSize}
          icon={FiHome}
          title={"Home"}
          description={"Home"}
          isActive={location.pathname === "/"}
          to={"/"}
        />
        {/* <NavItem
          navSize={navSize}
          icon={RiFileEditLine}
          title={"ERP Converter"}
          description={"Convert ERP to data ready"}
          isActive={location.pathname === "/convert_erp"}
          to={"/"}
        /> */}
        {/* <NavItem
          navSize={navSize}
          icon={FiHome}
          title={"Generate"}
          description={"Generate a burden"}
          isActive={location.pathname === "/generate"}
          to={"/generate"}
        /> */}
        {/* <NavItem
          navSize={navSize}
          icon={MdOutlineNoEncryptionGmailerrorred}
          title={"constraints"}
          description={"Edit Constraints"}
          isActive={location.pathname === "/constraints"}
          to={"/constraints"}
        /> */}
        <NavItem
          navSize={navSize}
          icon={MdMovieEdit}
          title={"Assumptions"}
          description={"Edit Assumptions"}
          isActive={location.pathname === "/editAssumptions"}
          to={"/editAssumptions"}
        />
        <NavItem
          navSize={navSize}
          icon={VscOutput}
          title={"Latest"}
          description={"output screen"}
          isActive={location.pathname === "/output"}
          to={"/output"}
        />
        <NavItem
          title="Deviation"
          navSize={navSize}
          icon={TbDelta}
          isActive={location.pathname === "/deviations"}
          to="/deviations"
        />
        <NavItem
          navSize={navSize}
          icon={FaHistory}
          title={"History"}
          description={"View your past schedules"}
          isActive={location.pathname === "/history"}
          to="/history"
        />
      </Flex>
      <Flex p="5%" flexDir="column" width="100%" alignItems="flex-start" mb="4">
        {navSize === "large" && <Divider />}
        <Flex mt="4" align="center" gap="3" justifyContent="center" w="100%">
          <Text display={navSize === "large" ? "flex" : "none"} color="white">
            {user.role === "guest" ? "Login" : "Logout"}
          </Text>
          <IconButton
            onClick={user.role === "guest" ? handleLogin : handleLogout}
            icon={user.role === "guest" ? <FiLogIn /> : <FiLogOut />}
            variant="outline"
            colorScheme={user.role === "guest" ? "green" : "red"}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SideBar;
